import { useEffect, useRef } from 'react';
import { useRecordRobbieAction } from '../../contexts/RobbieUiContext';
import { WizardPos } from '../../utils/wizardRoutes';
import { robbieActionText } from '../../utils/robbieActivity';
import { WIZARD_STEP_META } from './journeyModel';

/** Step 3's three screens share one title; the sub-step is what tells them apart. */
const DISCOVERY_SUBSTEP: Record<number, string> = { 1: 'questions', 2: 'validation', 3: 'suppliers' };

/**
 * Tells Robbie when the buyer moves to another screen of the wizard. Opening
 * the RFQ (or reloading) is not a move — only a change from the position
 * already on screen is recorded. `pos` is null while the RFQ is still loading.
 */
export const useRecordWizardNavigation = (rfqId: string, pos: WizardPos | null) => {
  const record = useRecordRobbieAction();
  const last = useRef<{ rfqId: string; key: string } | null>(null);
  const step = pos?.step;
  const subStep = pos?.subStep;

  useEffect(() => {
    if (step === undefined || subStep === undefined) return;
    const key = `${step}.${subStep}`;
    const previous = last.current;
    last.current = { rfqId, key };
    if (!previous || previous.rfqId !== rfqId || previous.key === key) return;
    const title = WIZARD_STEP_META[step]?.title ?? 'Wizard';
    const where = step === 3 ? `${title}: ${DISCOVERY_SUBSTEP[subStep] ?? 'questions'}` : title;
    record('navigate', robbieActionText.wentToStep(step, where));
  }, [rfqId, step, subStep, record]);
};
